export default __webpack_public_path__ + "18bd099ed9ea590867ab44f521bb2fc8.png";